import e from"react";import{Btn as t}from"./styles.js";const o=({hrefTarget:o,hasDescription:r,link:n,mode:s,testId:i,children:c})=>e.createElement(t,{testId:i,mode:r?"secondary":s,onClick:()=>{window.open(n,o?"_blank":"_self")}},c);export{o as Link};
//# sourceMappingURL=index.js.map
